import React, { useEffect, useState } from "react"
import InfoDetailsProduct from "../info-details-product/info-details-product"
import PerfectToProduct from "../perfect-to-product/prefect-to-product"
import ModalSizesIntima from "../modal-sizes-intima/modal-sizes-intima"
import Img from "gatsby-image"
import WinProduct, {
  SAMPLE_STEP_KEY,
  WIN_SAMPLE_ID,
  findPos,
} from "../win-product/win-product"

import "./details-product.scss"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const TABS = {
  DETAILS: 0,
  PERFECT_TO: 1,
  WIN_PRODUCT: 2,
}

const DetailsProduct = ({
  params,
  mobile,
  setModalActive,
  averageScore,
  numberOfRatings,
  granPatern,
  patern,
  paternTitle,
  title,
  isSecret,
}) => {
  const [activeTab, setActiveTab] = useState(TABS.DETAILS)
  const [modalSizes, setModalSizes] = useState(false)

  useEffect(() => {
    const step = sessionStorage.getItem(SAMPLE_STEP_KEY)
    const qString = new URLSearchParams(window.location.search).has("sample")
    if (step || qString) {
      setActiveTab(TABS.WIN_PRODUCT)
    }
  }, [])

  useEffect(() => {
    if (activeTab == TABS.WIN_PRODUCT) {
      const el = document.getElementById(WIN_SAMPLE_ID)
      const pos = findPos(el)
      window.scroll({ top: pos - 230, behavior: "smooth" })
    }
  }, [activeTab])


  const handleShowModalSizes = () => {
    setModalSizes(!modalSizes)
  }

  return (
    <>
      {modalSizes && <ModalSizesIntima close={() => handleShowModalSizes()} />}
      <section className="f-product-info">
        <div
          className={`f-header-card  ${
            activeTab !== TABS.WIN_PRODUCT ? "f-is-active" : ""
          }  `}
        >
          <h1 className="f-header-card__title">{title}</h1>
          <a
            className="f-backbutton"
            href={removeDoubleSlash("/productos/" + granPatern + "/" + patern)}
          >
            <span className="f-icon icon-left" /> VOLVER A {paternTitle}
          </a>
          <div className="f-product-tab-container">
            <div
              className={
                "f-product-tab " +
                (activeTab === TABS.DETAILS ? "f-tab-active" : "")
              }
              onClick={() => {
                setActiveTab(TABS.DETAILS)
              }}
            >
              <span>Detalles del producto</span>
            </div>
            <div
              className={
                "f-product-tab " +
                (activeTab === TABS.PERFECT_TO ? "f-tab-active" : "")
              }
              onClick={() => setActiveTab(TABS.PERFECT_TO)}
            >
              <span>Perfecto para:</span>
            </div>
          </div>
        </div>

        <div className="f-card-content">
          <InfoDetailsProduct
            isActive={activeTab === TABS.DETAILS}
            setModalActive={setModalActive}
            params={params}
            isSecret={isSecret}
            averageScore={averageScore}
            numberOfRatings={numberOfRatings}
            mobile={mobile}
            title={title}
          />

          {activeTab === TABS.PERFECT_TO && (
            <PerfectToProduct params={params} />
          )}

          <div
            className={`f-win-product-container ${
              activeTab === TABS.WIN_PRODUCT ? "f-active" : ""
            }`}
          >
            <div className="f-go-to-back">
              <button
                className="f-btn-go-to-product"
                onClick={e => {
                  e.preventDefault()
                  setActiveTab(TABS.DETAILS)
                }}
              >
                <span className="f-icon icon-left"></span> VOLVER AL PRODUCTO
              </button>
            </div>

            {TABS.WIN_PRODUCT === activeTab && (
              <WinProduct
                step={1}
                params={params}
                setShowWinSample={isVisible => {
                  if (isVisible) {
                    setActiveTab(TABS.WIN_PRODUCT)
                  } else {
                    setActiveTab(TABS.DETAILS)
                  }
                }}
                mobile={mobile}
                setModalActive={setModalActive}
              />
            )}
          </div>

          {params.actividadMuestreo && (
            <div
              className="f-sampling-banner-container"
              onClick={() => {
                setActiveTab(TABS.WIN_PRODUCT)
              }}
            >
              <Img
                className="f-sampling-banner"
                objectFit="contain"
                fluid={[
                  params.bannerInternaMuestreo[0].fluid,
                  {
                    media: `(max-width: 1024px`,
                    ...params.bannerInternaMuestreo[1].fluid,
                  },
                ]}
                alt={params.bannerInternaMuestreo[0].title}
              />
            </div>
          )}
        </div>
      </section>
    </>
  )
}

export default DetailsProduct
